<template>
  <div>
    <el-button type="primary" @click="dialogVisible = true">添加权限</el-button>
    <el-dialog title="添加权限" :visible.sync="dialogVisible" @close="resetForm">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="用户" prop="user_id">
          <el-select v-model="form.user_id" filterable remote reserve-keyword placeholder="输入用户账号" :remote-method="handleSearchUser">
            <el-option v-for="item in userList" :key="item.id" :label="item.account" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否禁止提现" prop="is_withdraw_disabled">
          <el-switch v-model="form.is_withdraw_disabled" active-color="#ff4949"
          inactive-color="#13ce66"/>
          
        </el-form-item>
        <el-form-item label="是否禁止下注" prop="is_bet_disabled">
          <el-switch v-model="form.is_bet_disabled" active-color="#ff4949"
          inactive-color="#13ce66"/>
        </el-form-item>
        <el-form-item label="是否冻结账户" prop="is_account_frozen">
          <el-switch v-model="form.is_account_frozen" active-color="#ff4949"
          inactive-color="#13ce66"/>
        </el-form-item>
        <el-form-item label="冻结金额" prop="frozen_amount">
          <el-switch v-model="form.frozen_amount" active-color="#ff4949"
          inactive-color="#13ce66"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-table :data="list" border style="width: 100%; margin-top: 20px;">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="user.account" label="用户账号" />
      <el-table-column prop="is_withdraw_disabled" label="是否禁止提现">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.is_withdraw_disabled"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @change="handleFrozenAmount(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="is_bet_disabled" label="是否禁止下注">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.is_bet_disabled"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @change="handleFrozenAmount(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="is_account_frozen" label="是否冻结账户">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.is_account_frozen"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @change="handleFrozenAmount(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="frozen_amount" label="冻结金额">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.frozen_amount"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @change="handleFrozenAmount(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="limit"
      :total="total"
      @current-change="handlePageChange"
      layout="prev, pager, next"
    />
  </div>
</template>

<script>
  import { getUserStatusList, createUserStatus, updateUserStatus } from '@/api/userStatus.js';
  import { getUsers } from '@/api/user.js';

  export default {
    data() {
      return {
        dialogVisible: false,
        form: {
          user_id: '',
          is_withdraw_disabled: false,
          is_bet_disabled: false,
          is_account_frozen: false,
          frozen_amount: 0,
        },
        rules: {
          user_id: [
            { required: true, message: '请输入用户ID', trigger: 'blur' },
          ],
        },
        list: [],
        userList: [],
        page: 1,
        limit: 10,
        total: 0,
      };
    },
    methods: {
      async handleSubmit() {
        try {
          const { data } = await createUserStatus(this.form);
          this.$message.success('添加成功');
          this.dialogVisible = false;
          this.getList();
        } catch (error) {
          this.$message.error(error.response.data.message);
        }
      },
      async getList() {
        const { data } = await getUserStatusList({ page: this.page, limit: this.limit });
        this.list = data.rows;
        this.total = data.count;
      },
      async handleFrozenAmount(row) {
        try {
          await updateUserStatus(row.id, row);
          this.$message.success('更新成功');
        } catch (error) {
          this.$message.error(error.response.data.message);
        }
      },
      handlePageChange(page) {
        this.page = page;
        this.getList();
      },
      resetForm() {
        this.$refs.form.resetFields();
      },
      async handleSearchUser(query) {
        const { data } = await getUsers({ keyword: query });
        console.log(data);
        this.userList = data.items;
      },
    },
    mounted() {
      this.getList();
    },
  };
  
</script>
